export const base64UrlEncode = (str) => {
    return btoa(str).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
};
export const generateJWT = async (header, payload, secret) => {
    const encoder = new TextEncoder();
    const data = base64UrlEncode(JSON.stringify(header)) + '.' + base64UrlEncode(JSON.stringify(payload));
    const key = await crypto.subtle.importKey('raw', encoder.encode(secret), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
    const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(data));
    return (data +
        '.' +
        base64UrlEncode(String.fromCharCode.apply(null, Array.from(new Uint8Array(signature)))));
};
